import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Flex, Box } from 'dash-ui';
import LogoImg from 'assets/images/png/logo.png';
import ProfileDropdown from 'flow-components/Header/components/ProfileDropdown/ProfileDropdown';

const HeaderStyle = styled(Flex)`
  border: 1px solid ${({ theme }) => theme.colors.n30};
  background-color: ${({ theme }) => theme.colors.white};
  position: fixed;
  z-index: 1;
`;

function Header({
  withProfileDropdown = true,
}: {
  withProfileDropdown?: boolean;
}) {
  const { t } = useTranslation('pages');
  return (
    <Box h={50}>
      <HeaderStyle
        flex={1}
        w="100%"
        h={50}
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <Flex>
          <Box ml={[4, 4, 14, 19]}>
            <img src={LogoImg} alt={t('pages:portalShell.logoAlt') || ''} width={96} height={24} />
          </Box>
        </Flex>
        {withProfileDropdown && <ProfileDropdown />}
      </HeaderStyle>
    </Box>
  );
}

export default Header;
